import {
  EnglishOnlyPattern,
  EmailRegex,
  PhoneNumberRegex2,
  DateRegex,
  OnlyAlphabeticRegex,
  BSBRegex,
  ShebaRegex,
  SwiftCodeRegex,
} from "./RegexPatterns";
import Utils from "./Utils";
export const Required = (v: any) => (!!v ? "" : "This field is required");
export const required = (v: any) => !!v || v === 0 || "This field is required";
export const onlyAlphabetic = (v: any) => OnlyAlphabeticRegex.test(v) || "Only alphabetic characters";
export const bsb = (v: any) => BSBRegex.test(v) || "Please enter a valid BSB";
export const sheba = (v: any) => ShebaRegex.test(v) || "Please enter a valid Sheba number";
export const swiftCode = (v: any) => SwiftCodeRegex.test(v) || "Please enter a valid Swift Code";
export const onlyEnglish = (v: any) => EnglishOnlyPattern.test(v) || "Only English text is allowed";
export const RequiredCheck = (v: any) => (!!v ? true : "This field is required");
export const ValidItem = (items: any) => (v: any) => items.indexOf(v) !== -1 ? true : "This field is required";
export const Email = (v: any) => (!!v && EmailRegex.test(v) ? "" : "E-mail must be valid");
export const EmailCheck = (v: any) => {
  const trimmedValue = v?.trim();
  return !!trimmedValue && EmailRegex.test(trimmedValue) ? true : "E-mail must be valid";
};
export const minLength = (minValue: any) => (v: any) => v.length >= minValue ? "" : `Min ${minValue} characters`;
export const arrayMinLength = (minValue: any) => (v: any) =>
  v != null && v != undefined && v.length >= minValue ? true : `At least ${minValue} item must be selected`;
export const minNumber = (minValue: any) => (v: any) =>
  v != null && v != undefined && Number(v) >= Number(minValue) ? true : `Value should be equal or more than ${minValue}`;
export const verificationCodeMinLength = (value: any) => (value && value.length == 6) || "The verification number should be 6 digits.";
export const confirmPassword = (passValue: any) => (value: any) => value == passValue ? true : "Password must match";
export const phoneNumber = (phone: string) => (PhoneNumberRegex2.test(phone) ? true : "Phone number must be valid");
export const optionalPhoneNumber = (phone: string) => (PhoneNumberRegex2.test(phone) || !phone || phone == "" ? true : "Phone number must be valid");
export const PhoneNumber = (phone: string) => (PhoneNumberRegex2.test(phone) ? "" : "Phone number must be valid");
export const ValidDate = (date: any) => (DateRegex.test(date) ? true : "Incorrect date type");
export const float = (v: any) => !v || /^(\-|\+)?[0-9]+(.[0-9]+)?$/gi.test(v) || "Just number is valid";
export const currency = (v: any) => !v || /^(\-|\+)?[0-9,]+(.[0-9]+)?$/gi.test(v) || "Just number is valid";
export const notZero = (v: any) => v != 0 || "Value cannot be 0";
export const minCharDesc = (v: any) => (v && v.length > 250) || "Please enter at least 250 characters";
export const step = (v: any) => v % 0.25 == 0 || "Please enter a value multiple of 0.25";
export const integer = (v: any) => /^[1-9]\d*$/.test(v) || "Please enter a positive whole number.";
export const httplink = (value: any) => Utils.validateUrlRegex(value) || "Please insert a valid Https Link";

export default {
  verificationCodeMinLength,
  ValidDate,
  minCharDesc,
  Required,
  required,
  RequiredCheck,
  ValidItem,
  Email,
  EmailCheck,
  minLength,
  arrayMinLength,
  minNumber,
  confirmPassword,
  optionalPhoneNumber,
  phoneNumber,
  PhoneNumber,
  float,
  currency,
  notZero,
  step,
  integer,
  httplink,
  onlyAlphabetic,
  bsb,
  sheba,
  swiftCode,
  onlyEnglish,
};
